import { initMapbox } from '../packs/init_mapbox';
import 'channels';
import "controllers";
import "config";

initMapbox();

